module.exports = __webpack_public_path__ + "img/Ondoklassniki.e6822ab9.svg";